import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: '52 Weekly Yoga Teaching Themes',
  value: '12',
  desc: 'A complete collection of 52 ready-to-use weekly themes to help you keep your classes fresh, meaningful, and engaging throughout the year. Each theme includes a central intention, teaching focus, class message, and closing reflection.',
  benefit: 'No preparation needed. Open, read, and teach.'
}, {
  id: '02',
  title: 'The Ultimate Yoga Cueing Library',
  value: '12',
  desc: 'A practical library of ready-to-say teaching cues for every moment of your class — openings, breathing, alignment, transitions, standing poses, balance, floor work, relaxation, and closing moments.',
  benefit: 'The words are already there. You just say them.'
}, {
  id: '03',
  title: 'Beginner Yoga Modification Guide',
  value: '10',
  desc: 'A clear reference guide with accessible modifications, prop options, and safer alternatives for beginners, students with limited mobility, stiffness, balance challenges, or reduced range of movement.',
  benefit: 'Have the right option ready before the class begins.'
}, {
  id: '04',
  title: '30 Emergency Ready-to-Teach Yoga Classes',
  value: '12',
  desc: 'A collection of 30 complete backup classes for the days when there is no time to plan. Includes short, gentle, active, restorative, chair-based, standard-length, and mixed-level options — all fully structured and ready to teach.',
  benefit: 'You will never walk into a class unprepared again. Open, choose, teach.'
}, {
  id: '05',
  title: 'Yoga Class Finder System',
  value: '12',
  desc: 'A quick-reference system that helps you choose the right class in under 60 seconds — based on duration, level, style, intensity, student type, available props, and group energy.',
  benefit: 'The system does the choosing. You do the teaching.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-dark-card border-y border-dark-border" data-id="element-17" data-mp="1c4kjmnai1klj">
      <div className="max-w-5xl mx-auto" data-id="element-18" data-mp="1c6ol6ykxe7in">
        <div className="text-center mb-16" data-id="element-19" data-mp="1q4d80byjzoqc">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-20" data-mp="1q1zdc47scejb">
            Included at no additional cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-21" data-mp="ycntupwazmsb">
            🎁 The 5 Strategic Bonuses
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-22" data-mp="tf44atu5nnl2">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-23" data-mp="176sh6zc8ag33" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-24" data-mp="5bxw0y4swuz8">
                BONUS {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-25" data-mp="ja5ootut1a4l">
                <Gift size={24} data-id="element-26" data-mp="o98s69v4z8ag" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16" data-id="element-27" data-mp="o6wazyx7d1yg">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-28" data-mp="eat3edjl0b44">
                <span className="text-gray-400 text-sm" data-id="element-29" data-mp="ecm99qmderb2">
                  Real value:{' '}
                  <span className="line-through" data-id="element-30" data-mp="2u41sjrxftahm">${bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-31" data-mp="2z2bo43n2qd3r">→ FREE</span>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-32" data-mp="3f9hj12aysr92">
                {bonus.desc}
              </p>

              <p className="text-gold-light text-sm italic font-medium" data-id="element-33" data-mp="3aflpcc1qhqjp">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-34" data-mp="30kts59c2d5pg">
          <p className="text-gray-300 mb-2" data-id="element-35" data-mp="3j9iapon2qyy2">Total value of the 5 bonuses</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-36" data-mp="2cuh8x2bdbmjk">$58.00</p>
          <p className="text-lg text-white mb-2" data-id="element-37" data-mp="27ubq8bn2tadm">Your price today</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-38" data-mp="nckf981fiucr">🎁 FREE</p>
          <p className="text-sm text-gold-light" data-id="element-39" data-mp="nahf3v6kbkub">
            Included only with this offer.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-40" data-mp="xb075d8a67nb" />
      </div>
    </section>;
}